import React from 'react'
import {css} from '@emotion/react'

import {ProcessStatus} from '../../../constants'
import ProcessStatusInfo from '../../../components/modules/ProcessStatusInfo'
import DataExportControl from '../../../components/modules/DataExportControl'
import InputResultPanelLayout from '../../../components/layouts/InputResultPanelLayout'
import useAsyncDataTransform from '../../../hooks/useAsyncDataTransform'
import ImageEditor from '../../../components/modules/ImageEditor'
import Jimp from 'jimp'


export default function ImageConverterLayout({
                                               targetFormat,
                                               downloadFileExt
                                             }) {
  const styles = {
    inputBottom: css`
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    `,

    bottomControlBar: css`
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      height: 36px;
    `,
  }

  const [inputImage, setInputImage] = React.useState(null)
  const onInputImageChange = React.useCallback((image) => {
    if (image instanceof Error) {
      setInputImage(null)
      return
    }
    setInputImage(image)
  }, [])

  const targetMimeType = React.useMemo(() => {
    switch (targetFormat) {
      case 'jpg':
        return Jimp.MIME_JPEG
      case 'png':
        return Jimp.MIME_PNG
      case 'bmp':
        return Jimp.MIME_BMP
      case 'tiff':
        return Jimp.MIME_TIFF
    }
  }, [targetFormat])

  const convertFunc = React.useCallback((image) => {
    if (!image) {
      return ['', '', null]
    }

    return Promise.all([
        image.getBase64Async(Jimp.AUTO),
        image.getBase64Async(targetMimeType),
        image.getBufferAsync(targetMimeType)
      ])
  }, [targetMimeType])

  const [processStatus, [inputImageDataURL, outputImageDataURL, outImageBuffer]] = useAsyncDataTransform(
    inputImage,
    convertFunc,
    {
      defaultOutput: ['', '', null],
      delayTime: 500,
      skipEmpty: false,
    }
  )

  return (
    <InputResultPanelLayout
      inputContent={(
        <ImageEditor
          loading={processStatus === ProcessStatus.Processing}
          dataURL={inputImageDataURL}
          onImageChange={onInputImageChange}

          status={<ProcessStatusInfo id="process-status" processStatus={processStatus}/>}
        />
      )}

      resultContent={(
        <ImageEditor
          readOnly
          loading={processStatus === ProcessStatus.Processing}
          dataURL={outputImageDataURL}

          extraControl={(
            <div css={styles.bottomControlBar}>
              <DataExportControl
                disabled={!outImageBuffer || outImageBuffer instanceof Error}
                data={outImageBuffer}

                copyEnabled={false}
                downloadEnabled={true}
                downloadButtonId={'download-button'}
                downloadFileExt={downloadFileExt}
              />
            </div>
          )}
        />
      )}
    />
  )
}

